import React from "react";
import { SITE } from "../lib/site";

export default function Mission() {
  return (
    <section
      id="mission"
      data-testid="mission-section"
      className="relative py-20 md:py-28"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-4">
            <span className="text-xs font-bold uppercase tracking-[0.18em] text-[#D85C41]">
              Our Mission
            </span>
            <h2 className="mt-3 font-display text-4xl md:text-5xl font-bold leading-[1.05] text-[#1C1917]">
              Our children deserve to walk into a classroom in clean clothes.
            </h2>
          </div>

          <div className="lg:col-span-8 space-y-6">
            <p className="text-lg md:text-xl text-[#57534E] leading-relaxed">
              For a child without stable housing, dirty clothes aren't just
              uncomfortable — they're a barrier. To friendships. To learning.
              To being seen as anything other than "the kid who smells."
            </p>
            <p className="text-base md:text-lg text-[#57534E] leading-relaxed">
              {SITE.name} (Children's Clean Day Kits of {SITE.city}) was
              founded by neighbors who believed that something as simple as a
              free wash and dry could give a child their confidence back. Our
              laundromat program runs on volunteers, donations, and the quiet
              conviction that dignity isn't a luxury.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
